import { FC } from 'react';
import { StoreLocationMap } from '../../store-location-map';
import { DealerLocationMapProps } from '../types';
import { getDrivingDirections } from '../../common/store-contact-info/utils';

export const DealerLocationMap: FC<DealerLocationMapProps> = ({
  userCountryCode,
  dealerCode,
  latitude,
  longitude,
  className
}) => {
  const redirectMap = () => {
    const drivingDirections = getDrivingDirections(latitude, longitude);
    window.open(drivingDirections);
  };
  return (
    <StoreLocationMap
      userCountryCode={userCountryCode}
      dealerCode={dealerCode}
      latitude={latitude}
      longitude={longitude}
      className={className}
      onClick={redirectMap}
    />
  );
};
